import React, { useContext } from "react";
import ErrorReports from "./ErrorReports";
import { GreenMachineContext } from "../GreenMachineContext";

export default function GreenMachineErrorReportsPage() {
  const { currentStage, STAGE_NUMBERS } = useContext(GreenMachineContext);

  if (currentStage !== STAGE_NUMBERS.errorReports) {
    return null;
  }

  return (
    <div className="gm-select-session-page-container">
      <React.Suspense fallback="Loading reports...">
        <ErrorReports />
      </React.Suspense>
    </div>
  );
}
